import { Stripe, loadStripe } from "@stripe/stripe-js";

let stripePromise;

// Using production/live Stripe key
const STRIPE_PUBLISHABLE_KEY = "pk_live_51K5GBrFYlaVPK4IAwi5jQNt4QkeuRNCmKqBHFw0ZzwfqsqlOqWowj9stUSzrad9lfPMfhorO0eKk5FWGJn3spPAo00cZlNDG5z";

const initializeStripe = async () => {
  if (!stripePromise) {
    stripePromise = await loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

export default initializeStripe;
